export interface EffectParams {
  // target: Effect;
  // endX: number;
  // endY: number;
  [index: string]: any;
}

export class Effect extends Phaser.GameObjects.Image {
  constructor(scene: Phaser.Scene, startX: number, startY: number, texture: string | Phaser.Textures.Texture, frame?: string | number) {
    super(scene, startX, startY, texture, frame);
  }
}
